import useIsMobile from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";
const CategoryPage = dynamic(() => import("@/screens/Category"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
// import CategoryPage from "@/screens/Category";
// import PageLayout from "@/screens/Layout/PageLayout";
import { stateData } from "@/constants/electionConfig";
import { useRouter } from "next/router";
export default function Category({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
}) {
  const router = useRouter();
 

  const subcategory = router?.asPath?.split("/election")[1]?.replace("/", "");
  const state_data = stateData[subcategory];
 
  const isMobileDevice = useIsMobile();
  // let metaData = {
  //   title: `2024 Maharashtra Vidhan Sabha Chunav: Maharashtra Assembly Chunav 2024, महाराष्ट्र विधानसभा चुनाव, Maharashtra Elections Updates - NewsTak`,
  //   description: `Maharashtra Assembly Elections 2024: Find the latest updates on the 2024 Maharashtra Assembly Chunav (महाराष्ट्र विधानसभा चुनाव 2024), including voting dates, exit polls, election results, candidate profiles, photos, videos of महाराष्ट्र चुनाव 2024, and expert analysis at NewsTak.`,
  //   keywords: `maharashtra chunav 2024, महाराष्ट्र विधानसभा चुनाव breaking News, maharashtra assembly election 2024, maharashtra assembly election news in hindi,महाराष्ट्र विधानसभा चुनाव परिणाम 2024, महाराष्ट्र चुनाव 2024, महाराष्ट्र चुनाव समाचार, महाराष्ट्र विधानसभा चुनाव समाचार`,
  // };
  return (
    <>
      <PageLayout
        rightSideBarData={categoryNewsListData}
        isMobileDevice={isMobileDevice}
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
      >
        
        <CategoryPage
          categoryNewsListData={categoryNewsListData}
          isMobileDevice={isMobileDevice}
          electionPassedCategory= 'delhi-assembly'
          masterKey= "delhi_election"
          stateName={state_data?.state} //"Delhi"
          stateHindi={state_data?.stateHindi} //"महाराष्ट्र"
          metaData={state_data?.metaData}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    //! this page path could be a subcategory page or a content detail page based on old url
    let url = ctx?.resolvedUrl;
    // redirection
   if (url?.includes("/election/delhi-assembly?")) {
    return {
      redirect: {
        destination: `${process.env.NEXT_PUBLIC_WEBSITE_URL}/election/delhi-assembly`,
        permanent: true, // Use `true` for 301 redirection
      },
    };
  }
    //* remove query param from url
    url = url.split("?")[0];
   
    const { getDataByUrl, getNewUrlByOldUrl, getNewUrlByOldSef } = await import(
      "@/handlers/commonApi"
    );
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { toBase64 } = await import("@/utils/url");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    let masterConfigData = await getMasterConfig();

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: page,
        display: 12,
        type: "all",
      },
    });
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });
    const redirectUrlRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getnewurl",
        oldUrl: toBase64(url),
      },
    });

    let [categoryNewsListData, latestStoryData, latestVideoData, redirectData] =
      await Promise.all([
        fetchRedisWrapper(categoryListRedisKey, () =>
          getDataByUrl({
            url: url,
            page: page,
            display: 12,
            type: "all",
          })
        ),
        fetchRedisWrapper(latestStoryRedisKey, () =>
          getLatestContentFeed({
            type: "story",
            page: 0,
            display: 5,
            unixtime,
          })
        ),
        fetchRedisWrapper(latestVideoRedisKey, () =>
          getLatestContentFeed({
            type: "video",
            page: 0,
            display: 5,
            unixtime,
          })
        ),
        fetchRedisWrapper(redirectUrlRedisKey, () =>
          getNewUrlByOldUrl({ oldUrl: url })
        ),
      ]);

    //* if redirect data is present then redirect to new url
    // console.log("redirectData", redirectData);
    // console.log("url", url);

    if (redirectData?.url && redirectData?.url?.length > 0) {
      let url = new URL(redirectData.url); //extract pathname from url with query params from url
      let pathname = url.pathname;

      let headerCache = redirectData?.cache;
      setPageTTL(ctx, headerCache?.akamai_ttl);

      return {
        redirect: {
          destination: `${process.env.NEXT_PUBLIC_WEBSITE_URL}` + pathname,
          statusCode: 301,
        },
      };
    }

    //* if categoryNewsListData is null or empty then return not found
    if (
      !categoryNewsListData ||
      Object.keys(categoryNewsListData).length === 0
    ) {
      let sefUrl = ctx?.params?.subcategory;
      // console.log("##Find Article By SefURL##", sefUrl);
      const redirectUrlRedisKey = getRedisApiKey({
        masterConfigData: masterConfigData,
        redisPrefix: "PREFIX_REDIS_ROS",
        params: {
          api: "getnewurl",
          sefUrl: sefUrl,
        },
      });
      let responseData = await fetchRedisWrapper(redirectUrlRedisKey, () =>
        getNewUrlByOldSef({ sefUrl: sefUrl })
      );
      // console.log("res", responseData);
      if (responseData?.url) {
        let url = new URL(responseData.url); //? extract pathname from url with query params from url
        let pathname = url.pathname;

        let headerCache = responseData?.cache;
        setPageTTL(ctx, headerCache?.akamai_ttl);
        return {
          redirect: {
            destination:
              `${process.env.NEXT_PUBLIC_WEBSITE_URL}${isAmp ? "/amp" : ""}` +
              pathname,
            statusCode: 301,
          },
        };
      } else {
        return {
          notFound: true,
        };
      }
    }

    let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, headerCache?.akamai_ttl);
    let stateSlugUrl = url?.split("/election")[0];
    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        stateSlugUrl: stateSlugUrl,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
